import React from 'react';
import { parse } from 'query-string';
import {Create, SimpleForm, ReferenceInput, TextInput, SelectInput} from 'react-admin';

export const FirmwareJobCreate = props => {
  console.log(parse(props.location));

  return (
    <Create>
        <SimpleForm>
            <ReferenceInput source="firmwareId" reference="firmwares" perPage={50}>
              <SelectInput optionText="version" />
            </ReferenceInput>
            {/* <TextInput label='Firmware Id' source="firmwareId" /> */}
            <TextInput label='Device Ids (CSV)' source="deviceIds" />          
            
        </SimpleForm>
    </Create>
  );
};
